import React, { Component } from "react";

let listenerCount = 0;

class EnterKeyClickWrapper extends Component {
  componentDidMount() {
    if (listenerCount === 0) {
      document.addEventListener("keydown", this.handleKeyDown);
    }
    listenerCount++;
  }

  componentWillUnmount() {
    listenerCount--;
    if (listenerCount === 0) {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      const activeElement = document.activeElement;
      if (activeElement && activeElement.tabIndex >= 0) {
        activeElement.click();
      }
    }
  };

  render() {
    return this.props.children;
  }
}

export default EnterKeyClickWrapper;
